import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-attendance',
  templateUrl: './main-attendance.component.html',
  styleUrls: ['./main-attendance.component.css']
})
export class MainAttendanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
